import { render, staticRenderFns } from "./PieEchart.vue?vue&type=template&id=36ae4567"
import script from "./PieEchart.vue?vue&type=script&lang=js"
export * from "./PieEchart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports